import classnames from 'classnames';
import { IMaskInput as ReactMaskInput } from 'react-imask';

import style from '../Input.module.scss';

export interface MaskedControlProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
    value: string | number;
    mask: string;
    alwaysShowMask?: boolean;
    formatChars?: Record<string, string | RegExp>;
    dataTest?: string;
    additionalClassNames?: string;
    inputRef?(el: HTMLElement): void;
    /** Вызывается только на изменения от пользователя. Переформатирование значения самой маской наверх не поднимается. */
    onChangeValue?(value: string, name?: string): void;
}

export function MaskedControl({
    value,
    mask,
    alwaysShowMask = false,
    formatChars = { 0: '[0]', '?': '[0]' },
    dataTest,
    additionalClassNames,
    inputRef,
    onChangeValue,
    ...props
}: MaskedControlProps) {
    const handleAccept = (acceptedValue: string, maskRef: unknown, inputEvent?: InputEvent): void => {
        const isReformattedByMask = !inputEvent;

        if (isReformattedByMask || acceptedValue === String(value ?? '')) {
            return;
        }

        onChangeValue?.(acceptedValue, props.name);
    };

    return (
        <ReactMaskInput
            className={classnames([style.input, !!additionalClassNames && additionalClassNames])}
            // @ts-ignore
            mask={mask || null}
            lazy={!alwaysShowMask}
            // @ts-ignore
            inputRef={inputRef ?? undefined}
            definitions={formatChars}
            type={'text'}
            autoComplete="off"
            data-test={dataTest}
            data-testid={dataTest}
            {...props}
            value={value as string}
            onAccept={handleAccept}
        />
    );
}
